import React, { useState, useContext, useEffect } from 'react'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import logo from '../../assets/logo.png'
import styles from '../../services/styles'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import './Login.css'

const { tc1, tc2, bc1, bc2, bc4, bc7, COLORS } = styles

export const Login = () => {

    const {
        loggedUser,
        mobile_mode
    } = useContext(GeneralContext)

    const navigate = useNavigate()

    useEffect(() => {
        if (loggedUser) {
            navigate('/', { replace: true })
        }
    }, [loggedUser])

    return (
        <>
            <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ height: '100%', background: COLORS.GRAY[50], display: mobile_mode ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', flex: 2 }}>
                    <img
                        src={logo}
                        style={{ width: '100%', maxWidth: 700, minWidth: 200 }}
                    />
                </div>

                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        position: 'relative',
                        minWidth: !mobile_mode && 450,
                        backgroundColor: 'black',
                        boxShadow: !mobile_mode && '-5px 0px 13px 0px rgba(156,156,156,1'
                    }}
                >
                    {/* Wave */}
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                        </g>
                    </svg>

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, padding: '20px 20px' }}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    )
}